import { DocumentVideoIcon } from "@sanity/icons"
import { defineField, defineType } from "@sanity-typed/types"
import React from "react"
import { SanityValues } from "sanity.config"
import Preview from "schemas/objects/helpers/Preview"
import { sizing } from "schemas/objects/helpers/sizing"

import { background } from "./helpers/background"
import WistiaInput from "./WistiaInput"

const type = defineType({
  type: "object",
  name: "wistiaEmbed",
  title: "Wistia Embed",
  icon: DocumentVideoIcon,

  fieldsets: [...background.fieldsets, ...sizing.fieldsets],

  fields: [
    ...background.fields,
    ...sizing.fields,
    defineField({
      name: "wistiaVideo",
      title: "Wistia Video",
      type: "object",
      fields: [
        defineField({
          name: "url",
          title: "URL",
          description:
            "Full video url e.g. https://vixiees.wistia.a/medias/dgd2h5ziuv",
          type: "string",
          validation: rule => rule.required(),
        }),
        defineField({
          name: "thumbnailUrl",
          title: "Thumbnail URL",
          type: "string",
          readOnly: true,
        }),
      ],
      components: {
        input: WistiaInput,
      },
    }),
    defineField({
      name: "cta",
      title: "CTA",
      type: "customCta",
    }),
    defineField({
      name: "ctaSubtitle",
      title: "CTA Subtitle",
      type: "string",
    }),
  ],

  components: {
    preview: () => <Preview title={type.title} icon={type.icon} />,
  },
})

export const wistiaEmbedSchema = type
export type WistiaEmbed = SanityValues["wistiaEmbed"]
